(() => {
  const modal = document.querySelector('[data-bek-photo-modal]');
  const openModal = (project = '') => {
    if (!modal) return false;
    modal.hidden = false;
    document.body.classList.add('bek-photo-modal-open');
    if (project) {
      const wanted = String(project).toUpperCase();
      const radio = modal.querySelector(`input[name="projectType"][value="${CSS.escape(wanted)}"]`);
      if (radio) radio.checked = true;
    }
    setTimeout(() => modal.querySelector('[data-photo-modal-close]')?.focus(), 0);
    return true;
  };
  const closeModal = () => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('bek-photo-modal-open');
  };
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-photo-modal-close]');
    if (close) { event.preventDefault(); closeModal(); return; }
    const link = event.target.closest('a[href="#foto-check"], [data-bek-photo-open]');
    if (link && modal) { event.preventDefault(); openModal(link.dataset.photoProject || ''); }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal && !modal.hidden) closeModal(); });

  const roots = document.querySelectorAll('[data-bek-photo-check]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const endpoint = root.dataset.endpoint || '/apps/bek-order/photo-check';
    const form = root.querySelector('[data-photo-form]');
    const panels = [...root.querySelectorAll('[data-photo-panel]')];
    const progress = [...root.querySelectorAll('[data-photo-progress]')];
    const errorBox = root.querySelector('[data-photo-error]');
    const fileInput = root.querySelector('[data-photo-files]');
    const drop = root.querySelector('[data-photo-drop]');
    const previews = root.querySelector('[data-photo-previews]');
    const submit = root.querySelector('[data-photo-submit]');
    const success = root.querySelector('[data-photo-success]');
    const successId = root.querySelector('[data-photo-success-id]');
    const formCard = root.querySelector('[data-photo-form-card]');
    let step = 1;
    let selectedFiles = [];
    let previewUrls = [];

    const showError = (message = '') => {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.classList.toggle('is-visible', Boolean(message));
    };

    const renderStep = () => {
      panels.forEach((p) => p.classList.toggle('is-active', Number(p.dataset.photoPanel) === step));
      progress.forEach((p) => p.classList.toggle('is-active', Number(p.dataset.photoProgress) === step));
      showError('');
      root.scrollIntoView({ behavior:'smooth', block:'start' });
    };

    const field = (name) => form.elements.namedItem(name);
    const projectChecked = () => form.querySelector('input[name="projectType"]:checked');

    const validateStep = (n) => {
      if (n === 1) {
        if (!projectChecked()) return 'Bitte wählen Sie zuerst Ihre Projektart.';
        if (!field('postalCode').value.trim()) return 'Bitte geben Sie Ihre PLZ ein.';
      }
      if (n === 2 && selectedFiles.length < 1) return 'Bitte laden Sie mindestens ein Foto hoch.';
      if (n === 3) {
        if (field('name').value.trim().length < 2) return 'Bitte geben Sie Ihren Namen ein.';
        if (!field('email').validity.valid || !field('email').value.trim()) return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
        if (!field('privacy').checked) return 'Bitte bestätigen Sie die Datenschutzhinweise.';
      }
      return '';
    };

    root.querySelectorAll('[data-photo-next]').forEach((btn) => btn.addEventListener('click', () => {
      const msg = validateStep(step);
      if (msg) return showError(msg);
      step = Math.min(3, step + 1);
      renderStep();
    }));
    root.querySelectorAll('[data-photo-back]').forEach((btn) => btn.addEventListener('click', () => {
      step = Math.max(1, step - 1);
      renderStep();
    }));
    progress.forEach((btn) => btn.addEventListener('click', () => {
      const target = Number(btn.dataset.photoProgress);
      if (target < step) { step = target; renderStep(); }
    }));

    const renderPreviews = () => {
      previewUrls.forEach((url) => URL.revokeObjectURL(url));
      previewUrls = [];
      previews.innerHTML = '';
      selectedFiles.forEach((file, index) => {
        const card = document.createElement('div');
        card.className = 'bek-photo-preview';
        const url = URL.createObjectURL(file);
        previewUrls.push(url);
        const img = document.createElement('img');
        img.src = url;
        img.alt = `Ausgewähltes Foto ${index + 1}`;
        img.onerror = () => { card.classList.add('bek-photo-preview--file'); card.textContent = file.name; };
        const remove = document.createElement('button');
        remove.type = 'button'; remove.setAttribute('aria-label', `Foto ${index + 1} entfernen`); remove.textContent = '×';
        remove.addEventListener('click', () => { selectedFiles.splice(index,1); renderPreviews(); });
        card.append(img, remove); previews.append(card);
      });
    };

    const addFiles = (incoming) => {
      const next = [...selectedFiles, ...Array.from(incoming || [])];
      const images = next.filter((f) => String(f.type || '').startsWith('image/')).slice(0, 5);
      if (!images.length && incoming?.length) return showError('Bitte wählen Sie Bilddateien aus.');
      selectedFiles = images;
      if (next.length > 5) showError('Es können maximal 5 Fotos gesendet werden.'); else showError('');
      renderPreviews();
    };

    fileInput?.addEventListener('change', (e) => { addFiles(e.target.files); fileInput.value = ''; });
    ['dragenter','dragover'].forEach((eventName) => drop?.addEventListener(eventName, (e) => { e.preventDefault(); drop.classList.add('is-drag'); }));
    ['dragleave','drop'].forEach((eventName) => drop?.addEventListener(eventName, (e) => { e.preventDefault(); drop.classList.remove('is-drag'); }));
    drop?.addEventListener('drop', (e) => addFiles(e.dataTransfer.files));

    async function compressPhoto(file) {
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size <= 2 * 1024 * 1024) return file;
      try {
        const bitmap = await createImageBitmap(file);
        const maxSide = 2200;
        const ratio = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
        const w = Math.max(1, Math.round(bitmap.width * ratio));
        const h = Math.max(1, Math.round(bitmap.height * ratio));
        const canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d'); ctx.drawImage(bitmap, 0, 0, w, h); bitmap.close?.();
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', .82));
        if (!blob) return file;
        const base = file.name.replace(/\.[^.]+$/, '') || 'foto';
        return new File([blob], `${base}.jpg`, { type:'image/jpeg', lastModified:Date.now() });
      } catch { return file; }
    }

    const preselect = () => {
      const params = new URLSearchParams(location.search);
      const raw = (params.get('project') || params.get('produkt') || '').toUpperCase();
      const aliases = { TDS:'TERRASSENDACH', SKYVIEW:'TERRASSENDACH', FLATLINE:'CARPORT', CARPORT:'CARPORT', SHADING:'BESCHATTUNG', BESCHATTUNG:'BESCHATTUNG', SG23:'GLASSCHIEBEWAND', GLASSCHIEBEWAND:'GLASSCHIEBEWAND', SUNPROPLUS:'LAMELLENDACH', SUNPRO:'LAMELLENDACH', LAMELLENDACH:'LAMELLENDACH' };
      const wanted = aliases[raw] || raw;
      const radio = form.querySelector(`input[name="projectType"][value="${CSS.escape(wanted)}"]`);
      if (radio) radio.checked = true;
    };
    preselect();

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const msg = validateStep(3);
      if (msg) return showError(msg);
      submit.disabled = true;
      const oldText = submit.textContent;
      submit.textContent = 'Fotos werden gesendet …';
      showError('');
      try {
        const prepared = [];
        for (const file of selectedFiles) prepared.push(await compressPhoto(file));
        if (prepared.some((f) => f.size > 8 * 1024 * 1024)) throw new Error('Mindestens ein Foto ist größer als 8 MB. Bitte wählen Sie ein kleineres Bild.');
        const fd = new FormData();
        ['name','email','phone','postalCode','city','width','depthHeight','notes','website'].forEach((key) => fd.append(key, field(key)?.value || ''));
        fd.append('projectType', projectChecked().value);
        fd.append('privacy', field('privacy').checked ? 'true' : 'false');
        prepared.forEach((file) => fd.append('photos', file, file.name));
        const response = await fetch(endpoint, { method:'POST', body:fd, headers:{ 'Accept':'application/json' } });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.ok) throw new Error(data.message || 'Der Foto-Check konnte gerade nicht gesendet werden.');
        formCard.style.display = 'none';
        success.classList.add('is-visible');
        if (successId) successId.textContent = data.id || '';
        success.scrollIntoView({ behavior:'smooth', block:'center' });
      } catch (error) {
        showError(error?.message || 'Der Foto-Check konnte gerade nicht gesendet werden.');
      } finally {
        submit.disabled = false;
        submit.textContent = oldText;
      }
    });
  });
})();
